import { Dropdown } from "antd";
import { useContext, useEffect, useRef, useState } from "react";
import ReactMarkdown from "react-markdown";
import { useNavigate } from "react-router";
import styled from "styled-components";
import AppContext from "../../../AppContext";
import ArchiveIcon from "../../../assets/icons/archive0.svg";
import arrowNarrowUpIcon from "../../../assets/icons/arrow-narrow-up0.svg";
import stopCircleIcon from "../../../assets/icons/stop-circle.svg";
import botagIconPurpleContainer from "../../../assets/icons/botag-icon-purple-container.svg";
import nanaBOLogo from "../../../assets/images/nanaBOLogo.png";
import DotsHorizontalIcon from "../../../assets/icons/dots-horizontal0.svg";
import EditIcon from "../../../assets/icons/edit-050.svg";
import file06 from "../../../assets/icons/file-06.svg";
import LogoutIcon from "../../../assets/icons/log-out-010.svg";
import paperclipIcon from "../../../assets/icons/paperclip0.svg";
import { ReactComponent as RefreshIcon } from "../../../assets/icons/refresh-ccw-010.svg";
import XCloseIcon from "../../../assets/icons/x-close.svg";
import { ReactComponent as XCloseIcon2 } from "../../../assets/icons/x-close1.svg";
import { formatDefaultDateTime } from "../../../utils/Formatter";
import * as Library from "../../../utils/Library";
import { uploadBuyerFileRequest } from "./chatWindowApi";
import { convertFileToDataUri } from "./ChatUtils";
import FullScreenLoader from "../loaders/FullScreenLoader";
import AllChatsPanel from "./AllChatsPanel";

// #region SCOPED CSS
export const StyledChatWindowContent = styled.div`
    &.chat-window {
        transition:
            opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
            transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        opacity: 0;
        transform: translateY(40px) scale(0.98);
        pointer-events: none;
        box-shadow: 0px -2px 10px 0px rgba(17, 22, 32, 0.8);
    }
    &.chat-window.isVisible {
        display: block;
        opacity: 1;
        transform: translateY(0) scale(1);
        pointer-events: auto;
    }
    &.chat-window.isHidden {
        display: block;
        opacity: 0;
        transform: translateY(40px) scale(0.98);
        pointer-events: none;
    }

    &.chat-window.full-screen,
    &.chat-window.full-screen .b-otag-ai-chat-widget {
        height: 100vh;
    }
    .b-otag-ai-chat-widget,
    .b-otag-ai-chat-widget * {
        box-sizing: border-box;
    }
    .b-otag-ai-chat-widget {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        height: 630px;
        position: relative;
    }
    .frame-1000011421 {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 5px 5px 0px 0px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        border-width: 0px 0px 1px 0px;
        padding: 12px 8px 12px 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .group-2 {
        flex-shrink: 0;
        width: 94.39px;
        height: 29.6px;
        position: static;
    }
    .divlabel {
        text-align: left;
        font-family: "ItcAvantGardeGothicProMd-Regular", sans-serif;
        font-size: 18.96491050720215px;
        font-weight: 400;
        position: absolute;
        left: 42.39px;
        top: 13.8px;
    }
    .label-span {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }
    .label-span2 {
        background:
            linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
            linear-gradient(
                199.32deg,
                rgba(96, 226, 93, 1) 28.1884104013443%,
                rgba(97, 35, 228, 1) 49.97871816158295%,
                rgba(90, 195, 254, 1) 62.99999952316284%,
                rgba(34, 255, 255, 1) 99.50000047683716%
            );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

        background: linear-gradient(199deg, #60e25d -52.98%, #6123e4 6.33%, #5ac3fe 41.77%, #2ff 141.12%);
        background-clip: text;
        font-size: 18.965px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .exclusion-7 {
        //width: 26.39px;
        height: 23.09px;
        position: absolute;
        left: 16px;
        top: 13.2px;
        overflow: visible;
    }
    .frame-1000011450 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .frame-110 {
        padding: 8.89px;
        display: flex;
        flex-direction: row;
        gap: 3.56px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        position: relative;
    }
    .dots-horizontal {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-113 {
        border-radius: 13332px;
        padding: 8.89px;
        display: flex;
        flex-direction: row;
        gap: 3.56px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        position: relative;
        aspect-ratio: 1;
    }
    .component-1 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-112 {
        padding: 8.89px;
        display: flex;
        flex-direction: row;
        gap: 3.56px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 32px;
        height: 32px;
        position: relative;
    }
    .x-close {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .all-messages-container {
        background: var(--backgrounds-and-lines-n-500, #141922);
        padding: 24px 16px;
        display: block;
        flex-direction: column;
        gap: 24px;
        align-items: flex-start;
        justify-content: flex-end;
        align-self: stretch;
        flex: 1;
        position: relative;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .all-messages-container::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }
    .message-container {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-top: 24px;
    }
    .user-icon {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        height: auto;
        position: absolute;
        overflow: visible;
        align-self: flex-start;
        z-index: 99;
        top: -25px;
        border: solid 3px var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 50px;
    }
    .user-icon.user {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        object-fit: cover;
        overflow: hidden;
    }

    .message-date-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        //padding-right: 32px;
        position: relative;
    }

    .message-container.bot .message-date-container {
        padding-right: 24px;
    }

    .message-container.user .message-date-container {
        padding-left: 24px;
    }

    .message-container.user .message-ballon {
        width: fit-content;
        justify-self: flex-end;
    }

    .message-ballon {
        background: #1e2631;
        border-radius: 16px;
        padding: 10px 15px 10px 15px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        min-height: 20px;
        max-width: 100%;
        width: fit-content;
    }
    .message-ballon img {
        max-width: 100%;
        height: auto;
    }
    .message-text-style {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        min-height: 20px;
        max-width: 100%;
        overflow-x: auto;
    }
    .message-datetime {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-top: 8px;
    }
    .message-datetime-style {
        color: var(--backgrounds-and-lines-n-100, #3c485a);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011416 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        border-width: 1px 0px 0px 0px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        //position: absolute;
        //left: 50%;
        //translate: -50%;
        bottom: 0px;
    }
    .frame-1000011411 {
        display: flex;
        flex-direction: row;
        gap: 6px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .frame-1000011407 {
        border-radius: 16px;
        border-style: solid;
        border-color: #5d3fd3;
        border-width: 1px;
        padding: 10px 20px 10px 8px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
        width: 100%;
    }
    .frame-1000011423 {
        background: #5d3fd3;
        border-radius: 16px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        position: relative;
        max-width: 100%;
        min-width: 0;
    }
    .file-06 {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .frame-1000011422 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        justify-content: center;
        flex-shrink: 1;
        position: relative;
        width: 100%;
        max-width: 100%;
        min-width: 0;
    }
    .replay-xlsx {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        max-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex-shrink: 1;
        width: 100%;
        overflow: hidden;
        max-width: 100%;
    }
    .file {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011448 {
        background: var(--primary-white-500, #ffffff);
        border-radius: 9999px;
        padding: 4px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: absolute;
        top: -6px;
        right: -6px;
        cursor: pointer;
    }
    .x-close2 {
        border-radius: 9999px;
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
        color: var("--backgrounds-and-lines-n-600");
    }
    .frame-10000114072 {
        background: #1e2631;
        border-radius: 16px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-100, #3c485a);
        border-width: 1px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 100%;
        position: relative;
    }
    .frame-111 {
        border-radius: 9999px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        border-width: 1px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        position: relative;
        align-self: self-end;
    }
    .paperclip {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .text-user {
        color: var(--text-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;

        //remove input default styles
        border: none;
        outline: none;
        background: transparent;
        padding: 0;
    }
    .frame-1102 {
        background: var(--text-and-icons-gray-100, #d1d1d1);
        border-radius: 16px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        position: relative;
        aspect-ratio: 1;
        align-self: self-end;
    }
    .arrow-narrow-up {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: relative;
        overflow: visible;
        aspect-ratio: 1;
    }
    .powered-by-chat-gpt {
        color: var(--backgrounds-and-lines-n-100, #3c485a);
        text-align: center;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
        align-self: stretch;
    }

    // --------------------
    .disabled-icon {
        opacity: 0.3;
        pointer-events: none;
    }
    .old-message {
        opacity: 1;
        transform: translateY(0);
        transition:
            opacity 0.4s,
            transform 0.4s;
    }
    .new-message {
        opacity: 0;
        transform: translateY(20px);
        animation: fadeInMessage 0.4s forwards;
    }
    @keyframes fadeInMessage {
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    // --------------------
    .message-container.user {
        flex-direction: row-reverse;
    }
    .message-container.user .message-date-container-sized {
        align-self: flex-end;
        max-width: 100%;
        overflow: hidden;
    }
    .message-container.user .message-ballon {
        background: #5d3fd3;
    }
    .message-container.user .message-datetime {
        justify-content: flex-end;
    }

    .message-loading {
        display: inline-block;
        width: 42px;
        position: relative;
        text-align: center;
    }
    .message-loading-dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #d1d1d1;
        border-radius: 50%;
        position: relative;
        animation: messageLoadingBounce 1s infinite alternate;
    }
    .message-loading-dot:nth-child(2) {
        left: 5px;
        animation-delay: 0.5s;
    }
    @keyframes messageLoadingBounce {
        0% {
            transform: translateY(0);
            opacity: 0.5;
        }
        50% {
            transform: translateY(-6px);
            opacity: 1;
        }
        100% {
            transform: translateY(0);
            opacity: 0.5;
        }
    }

    // --------------------
    .table-list-action-dropdown-normal {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px;
        padding: 8px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 161px;
        position: relative;
        box-shadow: var(--drop-shadow-100-box-shadow, 0px 0px 10px 0px rgba(17, 22, 32, 1));
    }
    .frame-74 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    &.frame-79 {
        border-radius: 4px;
        padding: 10px 8px 10px 8px;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    &.frame-79:hover {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
    }
    .edit-05 {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .new-chat {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
        height: 16px;
        line-height: 16px;
    }

    .ant-dropdown-menu {
        width: 161px !important;
    }
`;

const StyledDialogue = styled.div`
    &.dialog-box,
    &.dialog-box * {
        box-sizing: border-box;
        z-index: 9999;
    }
    &.dialog-box {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 16px 24px 16px 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        width: 286px;
        position: relative;
        box-shadow: var(--drop-shadow-200-box-shadow, 0px 0px 48.1px 0px rgba(17, 22, 32, 0.51));
        justify-self: center;
        position: absolute;
        top: 195px;
        left: 37px;
    }
    .frame-257 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .attention {
        color: var(--text-and-icons-red-500, #ff3636);
        text-align: center;
        font-family: var(--label-small-uppercase-font-family, "Roboto-Medium", sans-serif);
        font-size: var(--label-small-uppercase-font-size, 10px);
        line-height: var(--label-small-uppercase-line-height, 5px);
        letter-spacing: var(--label-small-uppercase-letter-spacing, 0.0125em);
        font-weight: var(--label-small-uppercase-font-weight, 500);
        text-transform: uppercase;
        position: relative;
        align-self: stretch;
    }
    .line-4 {
        margin-top: -1px;
        border-style: solid;
        border-color: var(--backgrounds-and-lines-n-200, #262e3e);
        border-width: 1px 0 0 0;
        align-self: stretch;
        flex-shrink: 0;
        height: 0px;
        position: relative;
    }
    .frame-258 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-285 {
        display: flex;
        flex-direction: column;
        gap: 32px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-160 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-286 {
        padding: 0px 32px 0px 32px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .ready-to-delete {
        color: #ffffff;
        text-align: center;
        font-family: "Roboto-Bold", sans-serif;
        font-size: 18px;
        font-weight: 700;
        position: relative;
        flex: 1;
    }
    .it-will-be-gone-forever {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-family: var(--subtitle-2-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--subtitle-2-font-size, 12px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
    .frame-255 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-large-solid-inverted-01 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        cursor: pointer;
    }
    .btn-small-filled {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 4px;
        padding: 10px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex: 1;
        height: 35px;
        position: relative;
    }
    .share {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--button-text-large-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--button-text-large-font-size, 12px);
        letter-spacing: var(--button-text-large-letter-spacing, 0.0125em);
        font-weight: var(--button-text-large-font-weight, 400);
        text-transform: uppercase;
        position: relative;
    }
`;
// #endregion

// #region CONSTANTS
const FILE_UPLOAD_PURPOSE = "Historical Data";
// #endregion

/** ChatWindow renders a chat interface with messages exchanged between the user and a bot.
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} props.isSidePanelFullScreen - Whether the chat window is in full screen mode for side panel.
 * @returns {JSX.Element} The rendered chat window with messages and input field.
 */
export default function ChatWindow(props) {
    // #region VARS
    const { isSidePanelFullScreen } = props;
    const navigate = useNavigate();
    const chatWindowRef = useRef(null);
    const fileInputRef = useRef(null);
    const [userInputText, setUserInputText] = useState("");

    const {
        aiChatLoading,
        aiChatIsVisible,
        aiChatSidePanelOpen,
        setAiChatSidePanelOpen,
        aiChatWindowOpen,
        setAiChatWindowOpen,
        showChatConversation,
        setShowChatConversation,
        showChatAllPanel,
        setShowChatAllPanel,
        aiChatMessages,
        setAiChatMessages,
        aiChatCurrentConversationID,
        setAiChatCurrentConversationID,
        setAiChatLoading,
        fileUpload,
        setFileUpload,
        //aiChatProductImporting,
        //setAiChatProductImporting,
        //aiChatPIMPFields,
        aiChatFetchingReply,
        setAiChatFetchingReply,
        setHasUnsavedChanges
    } = useContext(AppContext);
    //const appContext = useContext(AppContext);

    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [textAreaHeight, setTextAreaHeight] = useState("auto");
    // #endregion

    // #region METHODS
    const addNewMessage = message => {
        setAiChatMessages(prevMessages => [...prevMessages, message]);
    };

    const userAddNewMessage = () => {
        if (aiChatFetchingReply || aiChatLoading) return;

        if (showChatAllPanel) {
            const userName = localStorage.getItem("userFirstName") || localStorage.getItem("userLastName") || "User";

            setShowChatConversation(true);
            setShowChatAllPanel(false);
            setAiChatCurrentConversationID(null);
            setAiChatMessages([
                {
                    id: 1,
                    text: `Hi ${userName}, how can I help you?`,
                    sender: "bot",
                    timestamp: new Date(),
                    isLoadingMessage: !showChatAllPanel,
                    fileUpload: null
                }
            ]); // Clear messages for new chat
        }

        if (!userInputText.trim()) {
            Library.showToastMessage({
                type: "warning",
                message: "Please enter a message before sending.",
                autoClose: 2000
            });
            return; // Prevent sending empty messages
        }
        const currentID = aiChatMessages.length + 1;

        const newMessage = {
            id: currentID,
            text: userInputText,
            sender: "user",
            timestamp: new Date(),
            isLoadingMessage: false,
            fileUpload: fileUpload
        };

        addNewMessage(newMessage);
        setUserInputText(""); // Clear input after sending

        promptAIRequest({
            newID: currentID + 1,
            uploadedFiles: fileUpload.file ? [fileUpload.file] : [],
            fileName: fileUpload.file ? fileUpload.fileName : "",
            artifactID: fileUpload.file ? fileUpload.artifactID : null
        });
    };

    /* const expandButtonClicked = () => {
        const newIsSidePanelVisible = !aiChatSidePanelOpen;
        setAiChatSidePanelOpen(newIsSidePanelVisible);

        const newaiChatWindowOpen = !newIsSidePanelVisible;
        setAiChatWindowOpen(newaiChatWindowOpen);
    }; */

    const updateMessage = ({
        messageID,
        newText,
        isLoading = false,
        shouldScrollToMessage = true,
        delayMessageTimeout = 0
    }) => {
        setTimeout(() => {
            setAiChatMessages(prevMessages => {
                const updatedMessages = [...prevMessages];
                const messageIndex = updatedMessages.findIndex(msg => msg.id === messageID);
                if (messageIndex !== -1) {
                    updatedMessages[messageIndex] = {
                        ...updatedMessages[messageIndex],
                        text: newText,
                        isLoadingMessage: isLoading
                    };
                }

                // Scroll to the updated message if requested
                if (shouldScrollToMessage) {
                    scrollToMessage(messageID);
                }
                return updatedMessages;
            });
        }, delayMessageTimeout);
    };

    const scrollToMessage = messageID => {
        setTimeout(() => {
            const messageElement = chatWindowRef.current?.querySelector(`.chat-message-${messageID}`);
            messageElement?.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }, 100); // Delay to ensure the DOM is updated
    };

    const promptAIRequest = async ({ newID, uploadedFiles, fileName, artifactID }) => {
        const currentID = newID;
        const endpointName = /*Library.isLocalhost("promptAIchat") ? "promptAIchatMock" :*/ "promptAIchat";
        //const endpointName = "promptAIchat";

        /*const isImportingProducts = aiChatProductImporting?.isImporting || false;

         const productImportData = {
            stepNum: aiChatProductImporting?.currentStep || null,
            fileName: aiChatProductImporting?.fileName || null,
            file: aiChatProductImporting?.file || null,
             labelBrandID: aiChatPIMPFields?.labelBrandID || null,
            mandatoryFields: aiChatPIMPFields?.mandatoryFields || null,
            recommendedFields: aiChatPIMPFields?.recommendedFields || null,
            otherFields: aiChatPIMPFields?.otherFields || null,
            productsData: aiChatPIMPFields?.productsData || null
        };*/

        try {
            const formData = {
                promptText: userInputText,
                conversationID: aiChatCurrentConversationID,
                uploadedFiles: uploadedFiles || [],
                artifactID: artifactID || null,

                //pimpFields: isImportingProducts ? productImportData : null,
                //aiChatProductImporting: isImportingProducts,
                companyID: localStorage.getItem("currentCompanyID") || null,
                labelBrandID:
                    localStorage.getItem("currentLabelBrandID") || localStorage.getItem("defaultLabelBrand") || null,
                retailBrandID:
                    localStorage.getItem("currentRetailBrandID") || localStorage.getItem("defaultRetailBrand") || null,
                organizationID: localStorage.getItem("currentOrganizationID") || null,
                storeID: localStorage.getItem("currentStoreID") || localStorage.getItem("defaultStore") || null,
                BOstagesAccountID: localStorage.getItem("BOstagesAccountID") || null,
                BOstagesAccountName: localStorage.getItem("userFirstName") || null
            };

            const newMessage = {
                id: currentID,
                text: "...",
                sender: "bot",
                timestamp: new Date(),
                isLoadingMessage: true
            };
            removeFileUpload(); // Clear file upload state
            addNewMessage(newMessage);
            scrollToMessage(currentID);

            const res = await Library.makeCommonPostRequest(
                "AIchats",
                endpointName,
                formData,
                false,
                setAiChatFetchingReply,
                error => {
                    updateMessage({
                        messageID: currentID,
                        newText: error?.message
                            ? error?.message
                            : "There was an error trying to get a response from the AI. Please try again later.",
                        delayMessageTimeout: 500,
                        shouldScrollToMessage: true
                    });
                }
            );
            if (res?.data?.status !== 200) throw new Error(`Error: ${res?.data?.message || "Server response error."}`);

            const aiResponse = res?.data?.data?.reply;
            const toolCallsForFrontend = res?.data?.data?.toolCallsForFrontend || [];
            const conversationID = res?.data?.data?.conversationID;

            if (toolCallsForFrontend.length > 0) {
                if (Library.isLocalhost("promptAIchat", true))
                    console.warn(
                        "Tool calls for frontend:",
                        toolCallsForFrontend?.map(call => call?.functionName)
                    );

                /* #region CHECK TOOL CALLS */
                const navigateToPageCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "navigateToPage".toLowerCase()
                );
                /*const AIsearchProductColumnNamesCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "AIsearchProductColumnNames".toLowerCase()
                );
                const AIvalidateProductsMandatoryDataCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "AIvalidateProductsMandatoryData".toLowerCase()
                );
                const ImportProductsCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "ImportProducts".toLowerCase()
                );
                const CancelImportCall = toolCallsForFrontend.find(
                    call => call.functionName.toLowerCase() === "CancelImport".toLowerCase()
                );*/
                /* #endregion */

                /*if (CancelImportCall) {
                    const { status, reason } = CancelImportCall.endpointResult;

                    //resetAIProductImportingStates(appContext);
                    if (status !== 200) throw new Error(`Error: ${reason || "Server response error."}`);
                } */
                if (navigateToPageCall) {
                    setHasUnsavedChanges(false); // Reset unsaved changes state
                    const { route, labelBrandID, labelBrandName } = navigateToPageCall.endpointResult;
                    if (route) {
                        navigate(route, {
                            state: {
                                labelBrandID,
                                labelBrandName
                            }
                        });
                    } else {
                        console.warn("No route provided for navigateToPage tool call.");
                    }
                }
                /*if (!CancelImportCall && (AIsearchProductColumnNamesCall || AIvalidateProductsMandatoryDataCall)) {
                    const res =
                        AIsearchProductColumnNamesCall?.endpointResult ||
                        AIvalidateProductsMandatoryDataCall?.endpointResult;
                    if (res?.status !== 200) throw new Error(`Error: ${res?.message || "Server response error."}`);

                    const data = res?.data || [];
                    const step = res?.step?.toString() || null;

                    setAiChatProductImporting(prevState => ({
                        ...prevState,
                        isImporting: true,
                        currentStep: step,
                        fileName,
                        file: uploadedFiles?.[0] || prevState?.file,
                        step1Data: step === "1" ? data : prevState.step1Data,
                        step2Data: step === "2" ? data : prevState.step2Data,
                        step3Data: step === "3" ? data : prevState.step3Data,
                        validateMandatoryFieldsData: AIvalidateProductsMandatoryDataCall
                            ? data
                            : prevState.validateMandatoryFieldsData
                    }));
                }
                if (ImportProductsCall && !CancelImportCall) {
                    const res = ImportProductsCall?.endpointResult;
                    if (res?.status !== 200) throw new Error(`Error: ${res?.message || "Server response error."}`);

                    // if status is 200 then redirect to the products page
                    setHasUnsavedChanges(false);
                    //resetAIProductImportingStates(appContext);
                    setTimeout(() => {
                        navigate(`/products?labelBrandID=${aiChatPIMPFields.labelBrandID}`);
                    }, 300); // Delay to allow all state updates before navigation
                }*/
            }

            if (conversationID) setAiChatCurrentConversationID(conversationID);
            if (!aiResponse) throw new Error("AI response is empty or undefined.");

            updateMessage({ messageID: currentID, newText: aiResponse, isLoading: false, shouldScrollToMessage: true });
        } catch (error) {
            updateMessage({
                messageID: currentID,
                newText: error?.message
                    ? error?.message
                    : "There was an error trying to get a response from the AI. Please try again later.",
                delayMessageTimeout: 500,
                shouldScrollToMessage: true
            });
        }
    };

    const updateAIchatRequest = async (conversationID, name, status) => {
        const formData = {
            conversationID,
            name,
            status
        };
        //const res = await Library.makePostRequest("updateAIchat", formData, false, setAiChatLoading);
        const res = await Library.makeApiRequest({
            endpoint: "updateAIchat",
            data: formData,
            setLoader: setAiChatLoading
        });

        if (res?.data?.status !== 200) return false;

        return true;
    };

    const handleNewChat = () => {
        /*if (aiChatProductImporting?.isImporting) {
            navigate("/products");
            return;
        }*/
        const userName = localStorage.getItem("userFirstName") || localStorage.getItem("userLastName") || "User";
        setShowChatConversation(true);
        setShowChatAllPanel(false);
        setAiChatCurrentConversationID(null);
        removeFileUpload();
        setUserInputText("");
        setAiChatMessages([
            {
                id: 1,
                text: `Hi ${userName}, how can I help you?`,
                sender: "bot",
                timestamp: new Date(),
                isLoadingMessage: true
            }
        ]); // Clear messages for new chat

        //resetAIProductImportingStates(appContext);
    };

    const handleUploadClick = () => {
        const fileInput = fileInputRef.current;
        if (fileInput) {
            fileInput.click(); // Trigger file input click
        } else {
            Library.showToastMessage({
                type: "warning",
                message: "File upload input not found.",
                autoClose: 2000
            });
        }
    };

    const handleFileChange = async file => {
        if (!file) return;

        // use regular expression to check for valid file extensions
        const fileExtMatch = file.name.match(/\.(xls|xlsx|csv|pdf)$/i);

        if (!fileExtMatch) {
            Library.showToastMessage({
                type: "warning",
                message: "Please upload a valid Excel, CSV or PDF file.",
                autoClose: 2000
            });
            return;
        }

        let base64Data;

        try {
            base64Data = await convertFileToDataUri(file);
        } catch {
            removeFileUpload();
            Library.showToastMessage({
                type: "error",
                message: "Failed to convert file to a Data URI.",
                autoClose: 2000
            });
            return;
        }

        const artifactID = await uploadBuyerFileRequest({
            base64Data,
            purpose: FILE_UPLOAD_PURPOSE,
            setLoader: setAiChatLoading,
            onError: removeFileUpload
        });

        if (artifactID === undefined) return;

        if (!artifactID) {
            removeFileUpload();
            Library.showToastMessage({
                type: "error",
                message: "The file upload response did not include an artifact ID.",
                autoClose: 2000
            });
            return;
        }

        setFileUpload({
            file: base64Data,
            fileName: file.name,
            artifactID
        });
    };

    const removeFileUpload = () => {
        setFileUpload({ file: null, fileName: null, artifactID: null });
        const fileInput = fileInputRef.current;
        if (fileInput) {
            fileInput.value = ""; // Clear the file input value
        }
    };

    const handleCloseChat = () => {
        /*if (aiChatProductImporting?.isImporting) {
            navigate("/products");
            return;
        }*/

        setAiChatSidePanelOpen(false);
        setAiChatWindowOpen(false);
    };
    // #endregion

    // #region COMPUTED PROPS
    const isWindowVisible = aiChatIsVisible && (isSidePanelFullScreen ? aiChatSidePanelOpen : aiChatWindowOpen);
    const firstMessageIsLoading = aiChatMessages[0]?.isLoadingMessage;
    // #endregion

    // #region EFFECTS
    /*useEffect(() => {
        setHasUnsavedChanges(aiChatProductImporting?.isImporting);
    }, [aiChatProductImporting]);*/ // Update if has unsaved changes based on product importing state

    useEffect(() => {
        if (!isWindowVisible || !firstMessageIsLoading) return undefined;

        //update the first message to remove loading state after 1 second
        const loadingMessageTimeout = setTimeout(() => {
            setAiChatMessages(prevMessages => {
                if (!prevMessages[0]?.isLoadingMessage) return prevMessages;

                return prevMessages.map((message, index) =>
                    index === 0 ? { ...message, isLoadingMessage: false } : message
                );
            });
        }, 1000); // Simulate bot thinking time

        return () => clearTimeout(loadingMessageTimeout);
    }, [firstMessageIsLoading, isWindowVisible, setAiChatMessages]); // Update the first message when the chat window opens

    useEffect(() => {
        if (aiChatWindowOpen || aiChatSidePanelOpen) {
            if (aiChatMessages.length === 0) handleNewChat();
        }
    }, [aiChatWindowOpen, aiChatSidePanelOpen]); // Initialize chat if window or side panel opens

    useEffect(() => {
        if (userInputText === "") setTextAreaHeight("auto");
    }, [userInputText]); // Reset text area height when input is cleared
    // #endregion

    // #region RENDER
    return (
        <StyledChatWindowContent
            ref={chatWindowRef}
            className={`chat-window ${isWindowVisible ? "isVisible" : "isHidden"} ${
                isSidePanelFullScreen ? "full-screen" : ""
            } library-scrollable`}>
            <FullScreenLoader isLoading={aiChatLoading} />

            <div className="b-otag-ai-chat-widget">
                <div className="frame-1000011421">
                    <div className="group-2">
                        <div className="divlabel d-none">
                            <span className="label-span2">AI</span>
                        </div>
                        <img className="exclusion-7" src={nanaBOLogo} alt="botag-icon-purple.svg" />
                    </div>
                    <div className="frame-1000011450">
                        <div className="frame-110">
                            <ChatDropdown
                                setShowChatConversation={setShowChatConversation}
                                setShowChatAllPanel={setShowChatAllPanel}
                                updateAIchatRequest={updateAIchatRequest}
                                handleNewChat={handleNewChat}
                            />
                        </div>
                        <div className="frame-113 cursor-pointer" onClick={handleNewChat}>
                            <RefreshIcon className="component-1 text-normal" />
                        </div>
                        <div className="frame-112">
                            <img
                                className="x-close cursor-pointer"
                                src={XCloseIcon}
                                onClick={handleCloseChat}
                                alt="Close Chat"
                            />
                        </div>
                    </div>
                </div>
                <div className="all-messages-container">
                    {showDeleteDialog && <DialogBox setShowDeleteDialog={setShowDeleteDialog} />}

                    {showChatConversation ? (
                        aiChatMessages.map((message, index) => (
                            <MessageContainer
                                id={`chat-message-${message.id}`}
                                key={message.id}
                                message={message}
                                sender={message.sender}
                                text={message.text}
                                timestamp={message.timestamp}
                                isLoadingMessage={message.isLoadingMessage}
                                isNew={index === aiChatMessages.length - 1} // Mark the last message as new
                                fileUpload={message.fileUpload}
                            />
                        ))
                    ) : showChatAllPanel ? (
                        <AllChatsPanel setShowDeleteDialog={setShowDeleteDialog} />
                    ) : null}
                </div>
                <div className="frame-1000011416">
                    {fileUpload && fileUpload.file ? (
                        <div className="frame-1000011411">
                            <div className="frame-1000011407">
                                <div className="frame-1000011423">
                                    <img className="file-06" src={file06} alt="file" />
                                </div>
                                <div className="frame-1000011422">
                                    <div className="replay-xlsx">{fileUpload.fileName || "Uploaded File"}</div>
                                    <div className="file">File</div>
                                </div>
                            </div>
                            <div className="frame-1000011448">
                                <XCloseIcon2 className="x-close2" onClick={removeFileUpload} alt="Close File" />
                            </div>
                        </div>
                    ) : null}

                    <div className="frame-10000114072">
                        <div className="frame-111 cursor-pointer" onClick={handleUploadClick}>
                            <img className="paperclip" src={paperclipIcon} alt="paperclip0.svg" />

                            <input
                                ref={fileInputRef}
                                id="file-upload-input"
                                name="file-upload-input"
                                type="file"
                                className="hidden"
                                accept=".xls, .xlsx, .csv, .pdf"
                                onChange={e => {
                                    if (!e.target.files || e.target.files.length === 0) return;
                                    handleFileChange(e.target.files[0]);
                                }}
                            />
                        </div>
                        <textarea
                            className="text-user"
                            placeholder="Ask me anything..."
                            onChange={e => {
                                if (aiChatFetchingReply) return;
                                setUserInputText(e.target.value);
                                setTextAreaHeight(Math.min(e.target.scrollHeight, 7 * 24) + "px");
                            }}
                            value={userInputText}
                            rows={1}
                            style={{
                                resize: "none",
                                overflow: "auto",
                                maxHeight: 17 * 7,
                                minHeight: "auto",
                                height: textAreaHeight || "auto"
                            }}
                            onKeyDown={e => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    userAddNewMessage();
                                    setTextAreaHeight(Math.min(e.target.scrollHeight, 7 * 24) + "px");
                                }
                            }}
                        />
                        <div
                            className={`frame-1102 ${aiChatFetchingReply ? "cursor-not-allowed" : "cursor-pointer"}`}
                            onClick={userAddNewMessage}>
                            <img
                                className="arrow-narrow-up"
                                src={aiChatFetchingReply ? stopCircleIcon : arrowNarrowUpIcon}
                                alt="arrow-narrow-up0.svg"
                            />
                        </div>
                    </div>

                    <div className="powered-by-chat-gpt">Powered by OpenAI</div>
                </div>
            </div>
        </StyledChatWindowContent>
    );
    // #endregion
}

// #region SMALL COMPONENTS
const MessageContainer = ({ sender, text, timestamp, isNew, isLoadingMessage, id, fileUpload }) => {
    const userIcon = sender === "bot" ? botagIconPurpleContainer : null;
    const ballonPaddingY = sender === "bot" ? "18px" : "10px";

    const cleanedText = text.replace(/【\d+:\d+†[^†]+】/g, ""); // Remove the pattern 【4:0†store_enrollment_v5.md】

    return (
        <div className={`message-container ${sender} ${isNew ? "new-message" : "old-message"} ${id}`}>
            <div className="flex" style={{ flexDirection: "column", gap: "8px" }}>
                {fileUpload && fileUpload.file && (
                    <div
                        className="frame-1000011407"
                        style={{
                            maxWidth: "200px",
                            alignSelf: "end"
                        }}>
                        <div className="frame-1000011423">
                            <img className="file-06" src={file06} alt="file" />
                        </div>
                        <div className="frame-1000011422">
                            <div className="replay-xlsx">{fileUpload.fileName || "Uploaded File"}</div>
                            <div className="file">File</div>
                        </div>
                    </div>
                )}

                <div className="message-date-container">
                    <img
                        className={`user-icon ${sender} ${!userIcon ? "hidden" : ""}`}
                        src={userIcon}
                        alt="user-icon"
                    />
                    <div className="message-date-container-sized">
                        <div
                            className="message-ballon"
                            style={{ paddingTop: ballonPaddingY, paddingBottom: ballonPaddingY }}>
                            {isLoadingMessage ? (
                                <div className="message-text-style">
                                    <div className="message-loading">
                                        <span className="message-loading-dot"></span>
                                        <span className="message-loading-dot"></span>
                                    </div>
                                </div>
                            ) : (
                                <div className="message-text-style">
                                    <ReactMarkdown>{cleanedText}</ReactMarkdown>
                                </div>
                            )}
                        </div>
                        <div className="message-datetime">
                            <div className="message-datetime-style">{formatDefaultDateTime(timestamp)}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const ChatDropdown = ({ setShowChatConversation, setShowChatAllPanel, updateAIchatRequest, handleNewChat }) => {
    const { aiChatCurrentConversationID, setAiChatCurrentConversationID } = useContext(AppContext);

    return (
        <StyledChatWindowContent>
            <Dropdown
                trigger={["click"]}
                menu={{
                    items: [
                        {
                            key: "1",
                            label: <DropdownItem label="New Chat" onClick={handleNewChat} imgSrc={EditIcon} />
                        },
                        {
                            key: "2",
                            label: (
                                <DropdownItem
                                    label="Archive this chat"
                                    onClick={() => {
                                        if (!aiChatCurrentConversationID) {
                                            Library.showToastMessage({
                                                type: "warning",
                                                message: "No chat to archive.",
                                                autoClose: 2000
                                            });
                                            return;
                                        }

                                        updateAIchatRequest(aiChatCurrentConversationID, null, "archived").then(res => {
                                            if (!res) {
                                                Library.showToastMessage({
                                                    type: "error",
                                                    message: "Failed to archive chat.",
                                                    autoClose: 2000
                                                });
                                                return;
                                            } else {
                                                Library.showToastMessage({
                                                    type: "success",
                                                    message: "Chat archived successfully.",
                                                    autoClose: 2000
                                                });
                                            }
                                            setAiChatCurrentConversationID(null);
                                            setShowChatConversation(false);
                                            setShowChatAllPanel(true);
                                        });
                                    }}
                                    imgSrc={ArchiveIcon}
                                />
                            )
                        },
                        {
                            key: "3",
                            label: (
                                <DropdownItem
                                    label="Leave Chat"
                                    onClick={() => {
                                        setShowChatConversation(false);
                                        setShowChatAllPanel(true);
                                    }}
                                    imgSrc={LogoutIcon}
                                />
                            )
                        }
                    ]
                }}
                className="cursor-pointer Dropdown-menu-2"
                overlayStyle={{
                    zIndex: 99999,
                    marginTop: "8px",
                    width: "161px"
                }}
                overlayClassName="dropdown-regular"
                style={{
                    top: "10px"
                    //zIndex: 99999,
                }}
                placement="bottom">
                <img className="dots-horizontal" src={DotsHorizontalIcon} alt="dots-horizontal0.svg" />
            </Dropdown>
        </StyledChatWindowContent>
    );
};

const DropdownItem = ({ label, onClick, imgSrc }) => {
    return (
        <StyledChatWindowContent className="frame-79" onClick={onClick}>
            {imgSrc && <img className="edit-05" src={imgSrc} alt="img" />}
            <div className="new-chat">{label}</div>
        </StyledChatWindowContent>
    );
};

const DialogBox = ({ setShowDeleteDialog }) => {
    return (
        <StyledDialogue className="dialog-box">
            <div className="frame-257">
                <div className="attention">ATTENTION</div>
                <div className="line-4"></div>
                <div className="frame-258">
                    <div className="frame-285">
                        <div className="frame-160">
                            <div className="frame-286">
                                <div className="ready-to-delete">Delete Chat</div>
                            </div>
                            <div className="it-will-be-gone-forever">Are you sure you want to delete this chat?</div>
                        </div>
                        <div className="frame-255">
                            <div
                                className="btn-large-solid-inverted-01"
                                onClick={() => {
                                    setShowDeleteDialog(false);
                                }}>
                                <div className="btn-small-filled">
                                    <div className="share">NO</div>
                                </div>
                            </div>
                            <div
                                className="btn-large-solid-inverted-01"
                                onClick={() => {
                                    setShowDeleteDialog(false);
                                }}>
                                <div className="btn-small-filled">
                                    <div className="share">YES</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </StyledDialogue>
    );
};
// #endregion
